/* Pied de page CLIC : accordéons des menus sur téléphone (ouverture animée 0,3s, comme Symmetry)
   + bouton « Copier » du code promo après inscription + mémorise l'inscription (le popup ne s'affiche plus). */
(function () {
  const mq = window.matchMedia('(max-width: 767.98px)');

  function setOpen(acc, open, animate) {
    const head = acc.querySelector('.kc-acc__head');
    const panel = acc.querySelector('.kc-acc__panel');
    if (!head || !panel) return;
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!animate) {
      acc.classList.toggle('is-open', open);
      panel.style.height = open ? 'auto' : '';
      return;
    }
    const start = panel.getBoundingClientRect().height;
    acc.classList.toggle('is-open', open);
    panel.style.height = 'auto';
    const end = open ? panel.getBoundingClientRect().height : 0;
    panel.style.height = start + 'px';
    panel.offsetHeight; // reflow
    panel.style.height = end + 'px';
    const done = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      if (acc.classList.contains('is-open')) panel.style.height = 'auto';
    };
    panel.addEventListener('transitionend', done);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-kc-acc]:not([data-kc-ready])').forEach((acc) => {
      acc.setAttribute('data-kc-ready', '');
      setOpen(acc, !mq.matches, false);
      acc.querySelector('.kc-acc__head')?.addEventListener('click', () => {
        if (!mq.matches) return;
        setOpen(acc, !acc.classList.contains('is-open'), true);
      });
    });
    (root || document).querySelectorAll('.kc-footer [data-kc-copy]:not([data-kc-ready])').forEach((btn) => {
      btn.setAttribute('data-kc-ready', '');
      btn.addEventListener('click', async () => {
        const code = btn.getAttribute('data-kc-copy');
        let ok = false;
        try { await navigator.clipboard.writeText(code); ok = true; } catch (e) {
          const t = document.createElement('textarea');
          t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          try { ok = document.execCommand('copy'); } catch (e2) {}
          t.remove();
        }
        if (!ok) return;
        const label = btn.textContent;
        btn.textContent = btn.dataset.copied || 'Copié !';
        btn.classList.add('is-copied');
        setTimeout(() => { btn.textContent = label; btn.classList.remove('is-copied'); }, 2000);
      });
    });
    if ((root || document).querySelector('[data-kc-newsletter-ok]')) {
      try { localStorage.setItem('kc-newsletter-subscribed', String(Date.now())); } catch (e) {}
    }
  }

  const onMq = () => document.querySelectorAll('[data-kc-acc]').forEach((acc) => setOpen(acc, !mq.matches, false));
  mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
